import React from 'react';
import { ReportView } from '../components/ReportView.jsx';

export function MyReport({ data, onOpenClient, onOpenProject }) {
  return (
    <ReportView
      data={data}
      mode="mine"
      onOpenClient={onOpenClient}
      onOpenProject={onOpenProject}
    />
  );
}
